import { z } from "zod";

import { trimString } from "app/utils/trimString";

export const schema = z.object({
  name: z.preprocess(
    trimString,
    z.string().min(1, { message: "Policy collection name is required" }),
  ),
  provider: z.string(),
  repositoryUUID: z.string(),
  description: z.string().optional(),
  autoUpdate: z.boolean().optional(),
  repositoryView: z
    .object({
      branchName: z.string().optional(),
      policyDirectories: z.array(z.string()).nullish(),
      policyFileSuffix: z.array(z.string()).nullish(),
    })
    .optional(),
  owner: z
    .array(
      z.object({
        value: z.string(),
        label: z.string(),
        group: z.string(),
        type: z.enum(["User", "UserGroup"]),
      }),
    )
    .optional(),
  editor: z
    .array(
      z.object({
        value: z.string(),
        label: z.string(),
        group: z.string(),
        type: z.enum(["User", "UserGroup"]),
      }),
    )
    .optional(),
  accountGroups: z
    .array(z.object({ label: z.string(), value: z.string() }))
    .optional(),
  period: z.preprocess(
    (val) => (typeof val === "number" && isNaN(val) ? undefined : val),
    z.number().min(1, { message: "Period must be at least 1" }).optional(),
  ),
  unit: z.enum(["hour", "day"]).optional(),
  executeAssetDb: z.enum(["disabled", "enabled"]).optional(),
  policyActions: z.enum(["disabled", "enabled"]).optional(),
});

export type PolicyCollection = z.infer<typeof schema>;
